import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _BackLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { fill: "currentColor", d: "m4 10-.354.354L3.293 10l.353-.354zm16.5 8a.5.5 0 0 1-1 0zM8.646 15.354l-5-5 .708-.708 5 5zm-5-5.708 5-5 .708.708-5 5zM4 9.5h10v1H4zM20.5 16v2h-1v-2zM14 9.5a6.5 6.5 0 0 1 6.5 6.5h-1a5.5 5.5 0 0 0-5.5-5.5z" }) }) });
}
const BackLight = forwardRef(_BackLight);
export { BackLight };
